// Gating de features por grupo de testeo (`company_profiles.grupo_testing`).
//
// Fuente de verdad única para "quién ve qué". Tres funciones puras que usan
// tanto el Sidebar (desktop), la barra inferior (mobile), el landing inicial y
// los botones de navegación, así todos coinciden siempre.
//
// Modelo:
//  · dev_tester = true  → ve TODO (gana sobre el grupo).
//  · grupo_testing 'A' (o desconocido) → flujo clásico (Estudio Virtual →
//    seleccionar productos → "prueba nueva interfaz").
//  · grupo_testing 'B' → flujo V2 (Interfaz V2 + Modos).

export const GRUPO_A = "A";
export const GRUPO_B = "B";

/** Home del flujo clásico (Estudio Virtual → seleccionar productos). */
export const CLASSIC_STUDIO_PATH =
  "/redes-sociales/crear-anuncio/seleccionar-productos";
/** Home del flujo V2 (Interfaz V2). */
export const V2_STUDIO_PATH = "/interfaz-v2";

/**
 * Experiencia V2 (Interfaz V2 + Modos) en nav/tabs/acciones.
 * dev ve todo → true; Grupo B → true; Grupo A (o desconocido) → false.
 */
export function showsV2Studio(
  isDevTester: boolean | null | undefined,
  grupo: string | null | undefined,
): boolean {
  return isDevTester === true || grupo === GRUPO_B;
}

/**
 * Experiencia clásica (Estudio Virtual → seleccionar productos) en el nav.
 * dev ve todo → true; Grupo A (o desconocido) → true; Grupo B → false.
 */
export function showsClassicStudio(
  isDevTester: boolean | null | undefined,
  grupo: string | null | undefined,
): boolean {
  return isDevTester === true || grupo !== GRUPO_B;
}

/**
 * Landing inicial: SOLO Grupo B no-dev arranca en V2. dev y Grupo A → clásico.
 * (Difiere a propósito de `showsV2Studio`: el dev ve el nav V2 pero su landing
 * sigue siendo el clásico, igual que hoy.)
 */
export function landingIsV2(
  isDevTester: boolean | null | undefined,
  grupo: string | null | undefined,
): boolean {
  return isDevTester !== true && grupo === GRUPO_B;
}

/**
 * Destino del "home de estudio" tras generar imágenes (botones "Listo" /
 * "Seguir generando"). dev y Grupo B → V2; Grupo A → clásico (usa
 * `showsV2Studio`, igual que el botón "Listo" histórico).
 */
export function keepGeneratingStudioPath(
  isDevTester: boolean | null | undefined,
  grupo: string | null | undefined,
): string {
  return showsV2Studio(isDevTester, grupo) ? V2_STUDIO_PATH : CLASSIC_STUDIO_PATH;
}

/**
 * Destino del "home de estudio" para entradas/onboarding/retornos (post-
 * onboarding, "volver a config"). Solo Grupo B → V2; dev y Grupo A → clásico
 * (usa `landingIsV2`, igual que el landing de `/`).
 */
export function entryStudioPath(
  isDevTester: boolean | null | undefined,
  grupo: string | null | undefined,
): string {
  return landingIsV2(isDevTester, grupo) ? V2_STUDIO_PATH : CLASSIC_STUDIO_PATH;
}
